"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteJobLogById = exports.deleteBatchJobLogById = exports.cleanJobLog = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 删除定时任务调度日志表
 * @param id
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteJobLogById = exports.deleteJobLogById = function deleteJobLogById(id) {
  return _api.default.request({
    url: '/monitor/jobLog/delete',
    method: 'post',
    params: {
      id: id
    }
  });
};

/**
 * 批量删除定时任务调度日志表
 * @param ids
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchJobLogById = exports.deleteBatchJobLogById = function deleteBatchJobLogById(ids) {
  return _api.default.request({
    url: '/monitor/jobLog/deleteBatch',
    method: 'post',
    data: ids
  });
};

/**
 * 清空日志
 * @returns {AxiosPromise}
 */
var cleanJobLog = exports.cleanJobLog = function cleanJobLog() {
  return _api.default.request({
    url: '/monitor/jobLog/clean',
    method: 'post'
  });
};